import { useEffect, useRef } from 'react'

import { trackEventOnce } from 'services/analytics'

export default function CompetitiveImpression({ children, item, section }) {
  const element = useRef(null)
  const recorded = useRef(false)

  useEffect(() => {
    const node = element.current
    if (!node || typeof IntersectionObserver === 'undefined') return undefined
    const observer = new IntersectionObserver(entries => {
      if (recorded.current || !entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return
      recorded.current = true
      trackEventOnce('COMPETITIVE_CONTENT_IMPRESSION', {
        competitive_section: section,
        content_type: item.kind || item.recordType || section,
        content_id: item.id,
        competitor_id: item.competitor,
        competitive_source: item.source || item.platform,
      }, `${section}:${item.id}`, 30000)
      observer.disconnect()
    }, { threshold: 0.5 })
    observer.observe(node)
    return () => observer.disconnect()
  }, [item.competitor, item.id, item.kind, item.platform, item.recordType, item.source, section])

  return children(element)
}
